import { DataTypes } from "../../../data/DataManager";
import { FieldSchema } from "../../../Schema";

export const originalValues: FieldSchema = {
  name: "originalValues",
  graphql: { selection: undefined },
  // Never persisted, by either route: this exists to drive the form and the schema's own
  // cross-field logic, not to be stored.
  dataTransform: { toGraphql: undefined, toDb: undefined },
  data: { type: DataTypes.OBJECT },
  form: { disabled: true, displayed: false },
};
